window.wishlist_all_products = [];
window.wishlist_all_collections = [];
window.currently_active_collection = '';
window.wishlist_all_products_title = $('.cwp-wishlist-all-products-title').text();
$(document).ready(function(){
  function fetch_all_products(){
    window._swat.fetch( function(r) {
      wishlist_all_products = r;
      update_main_collection_view();
    });
  }

  function fetch_all_collections(){
    window._swat.getAllCollections(function(collections){
      wishlist_all_collections = collections;
      update_collections_view();
    });
  }

  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(fetch_all_products);

  window.SwymCallbacks.push(fetch_all_collections);

  function update_main_collection_view() {
    $('.cwp-all-collections-container').html('<div class="cwp-loader loader"></div>');
    if(wishlist_all_products.length){
      html = $($.parseHTML($('.cwp-collection-container-js').html()));
      html.find('.cwp-collection-count').html(wishlist_all_products.length)
      html.find('.cwp-collection-name').html(wishlist_all_products_title);
      html.find('.cwp-collection').data('collection-name', 'wishlist_all_products');
      $.each(wishlist_all_products, function(index, item){
        if(index == 4) {
          return false;
        }
        html.find(`.cwp-collection-image-container[data-index="${index}"]`).get(0).style.setProperty("--background_image", 'url('+item.iu+')');
      });
      $('.cwp-all-collections-container').html('');
      $('.cwp-all-collections-container').append(html);
      update_collections_navigation('wishlist_all_products');
    } else {
      $('.cwp-collection-container').hide();
      $('.cwp-all-collections-container').hide();
      $('.cwp-back-button').hide();
      $('.cwp-wishlist-empty').fadeIn();
    }
  }
  function update_collections_view(){
    if(!$.isEmptyObject(wishlist_all_collections)){
      $.each(wishlist_all_collections, function(name, items){
        html = $($.parseHTML($('.cwp-collection-container-js').html()));
        html.find('.cwp-collection-count').html(items.length)
        html.find('.cwp-collection-name').html(name);
        html.find('.cwp-collection').data('collection-name', name);
        $.each(items, function(index, value){
          if(index == 4) {
            return false;
          }
          product_index = wishlist_all_products.findIndex(x => x.epi == value);
          product = wishlist_all_products[product_index];
          html.find(`.cwp-collection-image-container[data-index="${index}"]`).get(0).style.setProperty("--background_image",'url('+product.iu+')');
        });
        $('.cwp-all-collections-container').append(html);
        update_collections_navigation(name);
      })
    }  
    
  }
  
  function update_collections_navigation(name){
    if(name == 'wishlist_all_products'){
      collection_name = wishlist_all_products_title;
      $('.cwp-nav-wrapper').html('');
    } else {
      collection_name = name;
    }
    html = $($.parseHTML($('.cwp-nav-item-js').html()));
    html.find('.cwp-nav-title').html(collection_name);
    html[1].setAttribute('data-collection-name', name);
    $('.cwp-nav-wrapper').append(html);
  }
  
  
  function show_collection(collection_name) {
  	$('.cwp-all-collections-container').hide();
    $('.cwp-collection-container').fadeIn();
    $('.cwp-products-grid').html('<div class="cwp-loader loader"></div>');
    $('.cwp-back-button').fadeIn();
    if(collection_name == 'wishlist_all_products') {
      $('.cwp-products-grid').html('');
      $.each(wishlist_all_products, function(index, item){
        html = $($.parseHTML($('.cwp-collection-item-container-js').html()));
        html.find('.cpi-image').prop('src', item.iu.replace('_620x620','_1000x1000'));
        html.find('.cpi-product-title').html(item.dt);
        html.find('.cpi-product-handle').html(item.dt + ' ' + item.ct);
        html.find('.cwp-remove-from-wishlist-button').data('product-epi', item.epi);
        html.find('.cpi-qc-link').prop('href', item.du);
        $('.cwp-products-grid').append(html);
      });
      $('.cwp-ctc-counter').html(wishlist_all_products.length);
    }else {
      collection_items = wishlist_all_collections[collection_name];
      $('.cwp-products-grid').html('');
      $.each(collection_items, function(index, value){
        item_index = wishlist_all_products.findIndex(x => x.epi == value);
        item = wishlist_all_products[item_index];
        html = $($.parseHTML($('.cwp-collection-item-container-js').html()));
        html.find('.cpi-image').prop('src', item.iu.replace('_620x620','_1000x1000'));
        html.find('.cpi-product-title').html(item.dt);
        html.find('.cpi-product-handle').html(item.dt + ' ' + item.ct);
        html.find('.cwp-remove-from-wishlist-button').data('product-epi', item.epi);
        html.find('.cpi-qc-link').prop('href', item.du);
        $('.cwp-products-grid').append(html);
      });
      $('.cwp-ctc-counter').html(collection_items.length);
    }
    $('.cmc-nav-title').removeClass('active');
    $(`.cmc-nav-title[data-collection-name="${collection_name}"]`).addClass('active');
    window.currently_active_collection = collection_name;
  }
  
  $(document).on('click', '.cwp-collection', function(){
  	collection_name = $(this).data('collection-name');
    show_collection(collection_name);
    scroll_to = $('.cwp-bar-container').position().top;
    $('html, body').animate({scrollTop:scroll_to}, 500);
  });
  
  
  $('.grid-switch').on('click', function(){
    $(this).parent().find('.grid-switch').removeClass('active');
    $(this).addClass('active');
    old_grid_desktop = getComputedStyle(document.documentElement).getPropertyValue('--collection_grid_desktop');
    old_grid_mobile = getComputedStyle(document.documentElement).getPropertyValue('--collection_grid_mobile');
    new_grid = $(this).data('grid');
    if ($(window).width() > 767){
      document.documentElement.style.setProperty('--collection_grid_desktop', new_grid);
    } else {
      document.documentElement.style.setProperty('--collection_grid_mobile', new_grid);
    }
  });

  $('.cct-orientation-switch').click(function(){
    $(this).toggleClass('change');
    $('body').toggleClass('landscape');
    $('.cct-orientation-item.active').removeClass('active').siblings('.cct-orientation-item').addClass('active');
    grid = $('.cct-orientation-item.active').data('grid');
    $('.grid-switch-desktop').find(`[data-grid="${grid}"]`).click();
  });
  
  $('.cct-orientation-item').click(function(){
    if (!$(this).hasClass('active')) {
      $('.cct-orientation-switch').click();
    }
  });
  
  $('.cwp-back-button').click(function(){
    $('.cwp-collection-container').hide();
  	$('.cwp-all-collections-container').fadeIn();
    $('.cwp-back-button').fadeOut();
  });
  
  $(document).on('click', '.cmc-nav-title', function(e){
  	collection_name = $(this).data('collection-name');
    show_collection(collection_name);
    if ($(window).width() < 767){
      if ($(this).hasClass('active')){
        $(this).parents('.cwp-nav-wrapper').toggleClass('open');
        return
      } else {
        $(this).parents('.cwp-nav-wrapper').removeClass('open');
      }
    };
  });
  
  $(document).on('click', '.cwp-remove-from-wishlist-button', function(e){
  	e.preventDefault();
    item_epi = $(this).data('product-epi');
    $('.cwp-products-grid').html('<div class="cwp-loader loader"></div>');
    window._swat.removeFromWishList(
      {
        "epi": item_epi
      },
      function(r) {
        console.log('Removed from wishlist');
        wishlist_all_products = $.grep(wishlist_all_products, function(item){return item.epi != item_epi});
        $.each(wishlist_all_collections, function(collection){
          collection_items = wishlist_all_collections[collection];
          new_collection_items = $.grep(collection_items, function(value){return value != item_epi});
          wishlist_all_collections[collection] = new_collection_items;
          if(!wishlist_all_collections[collection].length) {
            delete wishlist_all_collections[collection];
          }
        })

        if( wishlist_all_products.length ){
          update_main_collection_view();
          update_collections_view();
          if(typeof wishlist_all_collections[currently_active_collection] == 'undefined') {
            show_collection('wishlist_all_products');
          } else {
            show_collection(currently_active_collection);
          }
        } else {
          $('.cwp-collection-container').hide();
          $('.cwp-all-collections-container').hide();
          $('.cwp-back-button').hide();
          $('.cwp-wishlist-empty').fadeIn();
        }  
      }
    );
  })
});